import React,{Component} from 'react'
class EmptyPage extends Component{
    render(){
        return(
            <div>
                404
            </div>
        )
    }
  }
  export default EmptyPage